import { useNavigate, useSearchParams } from 'react-router-dom';
import '../App.css';
import { Button } from 'primereact/button';
import { useEffect, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import Header from '../Header';
import { allocateBudget } from '../QueryTransaction';
import { getBalance } from '../QueryAccount';

function CampaignBudgetAllocate() {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [accountBalanceE6, setAccountBalanceE6] = useState(0);
    const [amountToAllocate, setAmountToAllocate] = useState(0);

    useEffect(
        () => {
            getBalance().then(
                (response) => setAccountBalanceE6(response.data.balance_e6)
            ).catch(
                (error) => navigate('/')
            )
        },
        [],
    )

    return (
        <div align='center'>
            <Header />
            <div
                className='standard-box2'
                style={{ width: '90%', display: 'flex', alignItems: 'center' }}
            >
                <h2>
                    Allocate Budget for Campaign
                </h2>
                <div style={{ marginLeft: 'auto' }}>
                    <Button
                        label="Back"
                        severity="secondary"
                        onClick={
                            () => {
                                navigate(`/campaign/budget/?campaign_id=${searchParams.get('campaign_id')}`);
                            }
                        }
                        size='small'
                        style={{ marginRight: '0.5em' }}
                    />
                </div>
            </div>
            <div className='standard-box3'>
                <div>
                    Available Funds on Your Account:
                </div>
                <div style={{ marginTop: '1em' }}>
                    {(accountBalanceE6 / 100000).toFixed(2)} EUR
                </div>
            </div>
            <div className='standard-box3'>
                <h3>
                    Select the amount to allocate for this campaign:
                </h3>
                <InputText
                    value={amountToAllocate}
                    onChange={
                        (e) => {
                            if (e.target.value > accountBalanceE6) {
                                return;
                            }

                            setAmountToAllocate(e.target.value);
                        }
                    }
                    placeholder='amount to allocate'
                    className='text-input1'
                    type='number'
                />
                <div style={{ marginTop: '1em' }}>
                    EUR
                </div>
            </div>

            <div className='standard-box3'>
                <Button
                    label='Allocate'
                    severity='success'
                    size='small'
                    onClick={
                        () => {
                            allocateBudget(
                                searchParams.get('campaign_id'),
                                amountToAllocate,
                            ).then(
                                (response) => navigate('/campaigns/')
                            ).catch(
                                (error) => navigate('/')
                            )
                        }
                    }
                    disabled={amountToAllocate <= 0}
                />
            </div>
        </div>
    );
}

export default CampaignBudgetAllocate;